'use strict';

var React = require('react');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

function SvgNotification(props) {
    return (React__default.default.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", ...props },
        React__default.default.createElement("g", { fill: "none", fillRule: "evenodd" },
            React__default.default.createElement("path", { d: "M0 0h16v16H0z" }),
            React__default.default.createElement("path", { d: "M2 2h12v12H2z" }),
            React__default.default.createElement("path", { d: "M9.902 12.62C9.67 13.4 8.999 14 8.135 14c-.851 0-1.522-.59-1.756-1.36.272-.006.662-.008 1.093-.009h1.333c.431-.002.823-.004 1.097-.01zM8.135 2c.855 0 1.491.566 1.739 1.311 1.449.552 2.1 2.013 2.184 4.177.07.795.184 1.461.566 1.805.523.48 1.053 1.003 1.053 1.634 0 .566-.417.945-1.082.945H3.682c-.672 0-1.082-.38-1.082-.945 0-.63.523-1.154 1.053-1.634.382-.344.488-1.01.566-1.805.085-2.164.735-3.625 2.184-4.177C6.643 2.566 7.287 2 8.135 2z", fill: "currentColor" }))));
}

module.exports = SvgNotification;
//# sourceMappingURL=Notification.js.map
